import React from "react";
import {Box, Stepper, Step, StepLabel, StepConnector} from "@mui/material"
import { styled  } from "@mui/material/styles";

const steps = ["Persoanl Information", "Acedamic Infromation", "OTP verification"]

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${theme.breakpoints.up('xs')}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  '& .MuiStepConnector-line': {
    borderColor: theme.palette.grey[300],
    borderTopWidth: 2,
  },
  '&.Mui-active .MuiStepConnector-line': {
    // borderColor: theme.palette.primary.main,
    borderColor: '#6c3686',
  },
  '&.Mui-completed .MuiStepConnector-line': {
    // borderColor: theme.palette.primary.main,
    borderColor: '#6c3686',
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.grey[300],
  zIndex: 1,
  color: '#fff',
  width: 24,
  height: 24,
  display: 'flex',
  // borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '0.875rem',
  fontWeight: 'bold',
  ...(ownerState.active && {
    backgroundColor: '#6c3686',
    // backgroundColor: theme.palette.primary.main,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: '#6c3686',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? '✓' : icon}
    </ColorlibStepIconRoot>
  );
}

const FormProgress = ({currentStep})=>{
    return(
        <>
        <Box sx={{width : "100%", mb: 4}} className="stepper">
            <Stepper
            activeStep={currentStep -1}
            connector={<ColorlibConnector/>}
            sx={{
          '& .MuiStepLabel-root': {
            // padding: '8px',
          }
        }}
            >{
                steps.map((label, index)=>(
                    <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                    <Box 
                sx={{ 
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  fontWeight: currentStep - 1 >= index ? '600' : '400',
                  color: currentStep - 1 >= index ? 'primary.main' : 'text.secondary'
                }}
              >
                {label}
              </Box>
                    </StepLabel>
                    </Step>
                ))
            }

            </Stepper>
        </Box>
        </>
    )
}

export default FormProgress